<template>
    <div
        v-if="describeList"
        class="describe-container"
    >
        <div
            v-if="show"
            class="show"
        >
            <div class="ops-header">
                <div class="ops-left">
                    <!-- <div class="download-btn">
                        <i
                            class="el-icon-download"
                            aria-hidden="true"
                            @click="onDownload"
                        ></i>
                    </div> -->
                </div>
            </div>
            <div class="content">
                <div class="eidt-zone">
                    <div
                        v-for="item in describeList"
                        :key="item.id"
                        class="edit-container"
                    >
                        <div
                            v-if="item.url"
                            class="img-show"
                        >
                            <img
                                v-if="item.url"
                                :src="item.url"
                            />
                        </div>
                        <div class="text">
                            {{ item.text }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-else
            class="edit"
        >
            <div class="ops-header">
                <div class="ops-left">
                    <!-- 上传图片超过数量限制，则隐藏上传按钮 -->
                    <div
                        v-if="limit-picNum>0"
                        class="add-img"
                    >
                        <i
                            class="el-icon-picture"
                            aria-hidden="true"
                        ></i>
                        <input
                            v-if="30-picNum>0"
                            class="input-upload"
                            type="file"
                            name="file"
                            multiple
                            accept="image/*"
                            @change="onAddImage"
                        />
                    </div>
                    <!-- <div class="add-text">
                        <i
                            class="fa fa-font"
                            aria-hidden="true"
                            @click="createText('')"
                        ></i>
                    </div> -->
                    <!-- <div class="download-btn">
                        <i
                            class="el-icon-download"
                            aria-hidden="true"
                            @click="onDownload"
                        ></i>
                    </div> -->
                </div>
            </div>
            <div
                id="content"
                class="content"
            >
                <div
                    id="eidt-zone"
                    class="eidt-zone"
                >
                    <div
                        v-for="(item,index) in describeList"
                        :key="item.id"
                        class="edit-container"
                        @mouseenter="operate = index"
                        @mouseleave="operate = null"
                    >
                        <div
                            v-if="+item.type === 1"
                            class="img-show"
                        >
                            <img
                                v-if="item.url"
                                :src="item.url"
                            />
                            <div
                                v-show="operate === index"
                                class="ops"
                            >
                                <div class="ops-i">
                                    <div class="replace-img">
                                        <i class="el-icon-refresh"></i>
                                        <input
                                            class="input-upload"
                                            type="file"
                                            name="file"
                                            accept="image/*"
                                            @change="onChangeImage(index)"
                                        />
                                    </div>
                                    <div class="ops-text">
                                        <i
                                            class="el-icon-delete"
                                            aria-hidden="true"
                                            @click="deleteEle(index, 'image')"
                                        ></i>
                                        <i
                                            class="el-icon-zoom-in"
                                            @click="zoomImage(index)"
                                        ></i>
                                        <i
                                            v-if="index!= 0"
                                            class="el-icon-back transform90"
                                            aria-hidden="true"
                                            @click="upItem(index)"
                                        ></i>
                                        <i
                                            v-if="index!=describeList.length-1"
                                            class="el-icon-back transform-90"
                                            aria-hidden="true"
                                            @click="downItem(index)"
                                        ></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="+item.type === 0"
                            class="text-edit"
                        >
                            <div
                                :id="'text'+index"
                                class="text"
                                placeholder="请点击这里输入文本内容"
                                @focusout="saveText(this,index)"
                            >
                                {{ item.text }}
                            </div>
                            <div
                                v-if="operate === index"
                                class="ops-text"
                            >
                                <i
                                    class="el-icon-delete"
                                    aria-hidden="true"
                                    @click="deleteEle(index)"
                                ></i>
                                <i
                                    v-if="index!= 0"
                                    class="el-icon-back transform90"
                                    aria-hidden="true"
                                    @click="upItem(index)"
                                ></i>
                                <i
                                    v-if="index!=describeList.length-1"
                                    class="el-icon-back transform-90"
                                    aria-hidden="true"
                                    @click="downItem(index)"
                                ></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="查看图片"
            width="50%"
            :visible.sync="showModal"
        >
            <div class="modal-body">
                <img :src="currentImage" />
            </div>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    @click="showModal = false"
                >
                    关闭
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { uploadImg } from 'services/imageUpload';
import emitter from 'utils/emitter';
import { download } from 'utils/index';
import { cookie } from '@lsfe/tools';

function fileFIlter(file) {
    const picFormat = ['jpg', 'jpeg', 'png', 'gif'];
    const reg = new RegExp(`(${picFormat.join('|')})$`, 'i');
    return reg.test(file.name);
}

export default {
    componentName: 'validate-input',
    mixins: [emitter],
    props: {
        value: String,
        show: {
            type: Boolean,
            default: () => false,
        },
        skuBaseInfo: {
            type: Object,
        },
        // 是否增加暗水印
        dgWaterMark: {
            type: Boolean,
            default: false,
        },
        // 标识是商详-顶 or 商详-中 or 商详-底
        resourceType: {
            type: [Number, String],
            default: 2, // 默认是“商详-中”
        },
        // 上传图片的限制张数
        limit: {
            type: Number,
            default: 30, // 默认是“商品详情-中部”的限制
        },
    },
    data() {
        return {
            describeList: [],
            operate: null,
            // picUp: null,
            textEditUp: null,
            textShowUp: null,
            showModal: false,
            currentImage: '',
            showText: false,
        };
    },
    computed: {
        picNum() {
            return this.describeList.filter((i) => i.type === 1).length;
        },
    },
    watch: {
        value(newValue) {
            if (newValue) {
                this.describeList = JSON.parse(newValue);
            } else {
                this.describeList = [];
            }
        },
        describeList: {
            handler(list) {
                /**
                 * 给商详填充resourceType字段
                 * - 后端有返回：已上传图片，直接用
                 * - 后端无返回：新上传图片，补充resourceType信息
                 */
                const newList = list.map((item) => ({
                    ...item,
                    resourceType: item.resourceType || this.resourceType,
                }));
                this.$emit('input', list.length ? JSON.stringify(newList) : '');
            },
            deep: true,
        },
    },
    created() {
        this.$on('validate', this.onValidate);
        this.describeList = this.value ? JSON.parse(this.value) : [];
    },
    methods: {
        onDownload() {
            const srcs = this.describeList.map((v) => v.url).filter((v) => v);

            if (!srcs.length) {
                this.$message({
                    type: 'error',
                    message: '没有商品详情图片',
                });
                return;
            }

            const options = encodeURIComponent(
                JSON.stringify({
                    srcs,
                    operater: cookie.get('msid'),
                    fileprefix: `${this.skuBaseInfo.skuBaseId}_XQ`,
                    downloadname: `${this.skuBaseInfo.skuBaseId}_XQ`,
                    extname: 'zip',
                }),
            );

            let url = `/load/download?options=${options}`;

            if (process.env.NODE_ENV !== 'development') {
                url = `/product${url}`;
            }

            console.log(url);

            download(url);
        },
        // eslint-disable-next-line consistent-return
        onValidate() {
            const imageIdex = this.describeList.findIndex((item) => +item.type === 1 && (!item.width || !item.height));
            if (imageIdex >= 0) {
                return this.dispatch('validate-form', 'validate-message', `详情中第${imageIdex + 1}张图片无宽高值, 请删除`);
            }
            const textIndex = this.describeList.findIndex((item) => +item.type === 0 && !item.text);
            if (textIndex >= 0) {
                return this.dispatch('validate-form', 'validate-message', `详情中第${textIndex + 1}个文本块为空, 请删除`);
            }
        },
        createPic(url) {
            const params = {
                id: `image${new Date().getTime()}${Math.floor(Math.random() * 100)}`,
                type: 1,
                text: null,
                url,
                width: null,
                height: null,
            };
            this.describeList.push(params);
            return params;
        },
        deletePicById(id) {
            const index = this.describeList.findIndex((item) => item.id === id);
            if (index !== -1) {
                this.describeList.splice(index, 1);
            }
        },

        // createText(text) {
        //     if (this.validateText()) {
        //         const para = {
        //             id: `text${new Date().getTime()}`,
        //             type: 0,
        //             text,
        //             url: null,
        //         };
        //         this.describeList.push(para);
        //     }
        // },
        initDescribe(list) {
            if (list && list.length && list[0].description) {
                this.describeList = JSON.parse(list[0].description);
            }
        },
        deleteEle(id) {
            this.describeList.splice(id, 1);
            this.$emit('modify-success');
        },
        upItem(id) {
            const tem = this.describeList[id - 1];
            const temid = this.describeList[id];
            this.describeList.splice(id - 1, 1, temid);
            this.describeList.splice(id, 1, tem);
        },
        downItem(id) {
            const tem = this.describeList[id + 1];
            const temid = this.describeList[id];

            this.describeList.splice(id + 1, 1, temid);
            this.describeList.splice(id, 1, tem);
        },
        zoomImage(index) {
            const url = this.describeList[index].url;
            this.currentImage = url;
            if (url) {
                this.showModal = true;
            }
        },
        saveText(e, index) {
            const text = document.getElementById(`text${index}`).innerHTML;
            this.describeList[index].text = text;

            document.getElementById(`text${index}`).innerHTML = text;
        },

        // eslint-disable-next-line consistent-return
        onAddImage() {
            // eslint-disable-next-line no-restricted-globals
            let files = event.target.files || event.dataTransfer.files;
            files = Array.prototype.filter.call(files, fileFIlter);
            // 上传图片张数超过最大张数
            if (!this.validateNum(files.length)) return false;
            for (let index = 0; index < files.length; index++) {
                const file = files[index];
                // 先创建空图片
                // 20191201 by yangshan08
                // CHANGE1 原来会在createPic方法中往describeList中塞对象，现在把这个操作放到校验通过的回调中
                // 因为如果上传的不是图片，那么就不会触发onload事件，这也不会报错，从而只有添加而没有deletePicById操作
                // 导致一个没有url，没有宽高的对象存在于describeList中，导致报错，不能保存。
                // CHANGE2 在validatePic中如果通过，就直接把宽高信息放到picInfo中，这样就不用在setPicSize再触发一次onload

                // 20210109 by yangshan08
                // 发现的问题：如果在校验通过后再往describeList中塞对象，那么先校验完的会在前面，无法保证顺序
                // 解决办法：恢复CHANGE1,改为在上传文件时限定文件类型
                const picInfo = this.createPic();
                const id = picInfo.id;
                // eslint-disable-next-line no-unused-vars
                const originLen = this.describeList.length;
                this.validatePic(file, picInfo)
                    .then((url) => {
                        picInfo.url = url;
                        this.setPicInfo(id, picInfo);
                        if (!picInfo.width || !picInfo.height) {
                            this.setPicSize(id);
                        }
                        this.$emit('modify-success');
                    })
                    .catch((err) => {
                        // 上传失败,删除占位图片
                        this.deletePicById(id);
                        this.$notify.error({
                            title: `第${index + 1}张图片: ${file.name}`,
                            message: err.message,
                        });
                    });
            }

            // eslint-disable-next-line no-restricted-globals
            event.target.value = '';
        },

        onChangeImage(index) {
            // eslint-disable-next-line no-restricted-globals
            const files = event.target.files || event.dataTransfer.files;
            if (!files.length) return;
            const file = files[0];
            // eslint-disable-next-line no-restricted-globals
            event.target.value = '';

            this.validatePic(file)
                .then((url) => {
                    this.describeList[index].url = url;
                    this.setPicSize(this.describeList[index].id);
                })
                .catch((err) => {
                    this.$notify.error({
                        title: `${file.name}`,
                        message: err.message || '上传图片失败',
                    });
                });
        },

        setPicInfo(id, info) {
            const describe = this.describeList.find((item) => item.id === id);
            describe.width = info.width;
            describe.height = info.height;
            describe.url = info.url;
        },
        setPicSize(id) {
            const image = new Image();
            const describe = this.describeList.find((item) => item.id === id);
            image.src = describe.url;
            image.onload = () => {
                describe.width = image.width;
                describe.height = image.height;
                const index = this.describeList.findIndex((item) => item.id === id);
                this.describeList[index] = describe;
                this.describeList = this.describeList.concat([]);
            };
        },
        validateNum(uploadNum) {
            const remain = 30 - this.describeList.filter((i) => i.type !== 1).length - this.picNum;
            if (remain < uploadNum) {
                this.$message({
                    type: 'error',
                    message: `上传图片不能超过30个, 还能上传${remain}张`,
                });
            }
            return remain >= uploadNum;
        },
        validateText() {
            const hasEmpty = this.describeList.some((item) => item.type === 0 && !item.text);
            if (hasEmpty) this.$message.error('图文描述文本块内容不能为空,请补充或删除');
            return !hasEmpty;
        },

        validatePic(file, picInfo) {
            return new Promise((res, rej) => {
                const url = window.URL.createObjectURL(file);
                const image = new Image();
                let errMsg = '';
                image.src = url;

                image.onload = () => {
                    if (image.width < 720) {
                        errMsg = '图片宽度不能小于720px;';
                    }
                    if (file.size > 500 * 1024) {
                        errMsg += '图片不能大于500kb;';
                    }

                    if (errMsg) {
                        rej(new Error(`${errMsg}`));
                    } else {
                        if (picInfo) {
                            picInfo.width = image.width;
                            picInfo.height = image.height;
                        }
                        res(this.upload(file));
                    }
                };
            });
        },
        upload(file) {
            const reqData = {
                file,
            };
            // 0310：暂时下掉暗水印入口
            // if (this.dgWaterMark) reqData.dgWaterMark = this.dgWaterMark;
            return uploadImg
                .call(this, reqData)
                .then((data) => {
                    if (!data.url) {
                        throw new Error('上传失败，请重试');
                    } else {
                        return data.url;
                    }
                });
        },
    },
};
</script>

<style lang="scss" scoped>

.transform90 {
    transform: rotate(90deg);
}
.transform-90 {
    transform: rotate(-90deg);
}
.describe-container {
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    width: 100%;
    .input-upload {
        z-index: 1;
        opacity: 0;
        font-size: 20em;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        width: 100%;
        height: 100%;
    }
    .ops-header {
        background: #f7f7f7;
        height: 50px;
        .ops-left {
            &:after {
                content: "";
                display: table;
                clear: both;
            }
            position: relative;
            display: inline-block;
            float: left;
            line-height: 50px;
            font-size: 32px;
            margin-left: 20px;
            div {
                position: relative;
                float: left;
                width: 52px;
                height: 50px;
                cursor: pointer;
            }
            div + div {
                margin-left: 10px;
            }
            .add-img {
                overflow: hidden;
            }
        }
        .preview {
            display: inline-block;
            float: right;
            margin-top: 7px;
            margin-right: 20px;
        }
    }
    .content {
        min-height: 620px;
        overflow-y: scroll;
        text-align: center;
        width: 100%;
        background: #666666;
        .eidt-zone {
            margin: 10px auto;
            padding-top: 15px;
            width: 375px;
            min-height: 600px;
            background: #ffffff;
            .edit-container {
                position: relative;
                // padding-bottom:5px;
                display: block;
                .img-show {
                    width: 375px;
                    /*height: 281px;*/
                    position: relative;
                    margin-left: auto;
                    margin-right: auto;
                    // margin-bottom: 15px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                    &.img-show:hover {
                        border-top: 1px solid #999999;
                        border-bottom: 1px solid #999999;
                    }
                    .ops {
                        z-index: 1;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        // position:relative;
                        width: 375px;
                        height: 28px;
                        line-height: 28px;
                        text-align: center;
                        background: #fff;
                        opacity: 0.6;
                        .ops-i {
                            width: 180px;
                            margin-left: auto;
                            margin-right: auto;
                        }
                        .replace-img {
                            display: inline-block;
                            position: relative;
                            overflow: hidden;
                        }
                        .ops-text {
                            display: inline-block;
                            overflow: hidden;
                        }
                        i {
                            line-height: 28px;
                            width: 28px;
                            font-size: 16px;
                            color: #777;
                            cursor: pointer;
                            &:hover {
                                color: #333;
                            }
                        }
                    }
                }

                .text-edit {
                    // padding:10px 10px;
                    margin: 10px auto;
                    /*margin-left: auto;*/
                    /*margin-right: auto;*/
                    cursor: auto;
                    outline: 0;
                    width: 330px;
                    position: relative;
                    color: #333333;

                    .text {
                        text-align: left;
                        // min-height: 30px;
                        -webkit-user-modify: read-write-plaintext-only;
                        font-family: PingFangSC-Light;
                        font-size: 13px;
                        line-height: 19px;
                        letter-spacing: 1px;
                        padding-top: 3px;
                        padding-bottom: 3px;
                    }
                    .text[placeholder]:empty:before {
                        content: attr(placeholder);
                        padding-top: 10px;
                        padding-bottom: 10px;
                        font-size: 12px;
                        display: block;
                        border: 1px dashed #aaa;
                    }
                    .text[placeholder]:empty:focus:before {
                        content: "";
                        padding: 0 0;
                        border: 0;
                        min-height: 15px;
                    }
                    &.text-edit:hover {
                        border: 1px solid #999999;
                        padding: 10px 10px;
                        margin-top: 10px;
                        margin-bottom: 10px;
                    }
                    .ops-text {
                        position: relative;
                        top: 5px;
                        height: 28px;
                        line-height: 28px;
                        text-align: center;
                        background: #fff;
                        opacity: 0.6;
                        i {
                            line-height: 28px;
                            width: 28px;
                            font-size: 16px;
                            color: #777;
                            cursor: pointer;
                            &:hover {
                                color: #333;
                            }
                        }
                    }
                }
                .edit-area {
                    z-index: 1;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                }
            }
        }
    }
    .modal-body {
        text-align: center;
        img {
            max-width: 480px;
            max-height: 360px;
        }
    }
}
</style>
